module.exports = __webpack_public_path__ + "static/media/KioskPaymentScreen.13bfa74d.png";